export enum ProductTableColumn {
  Adjustments = "adjustments",
  ProductName = "productName",
  Product = "product",
  Variant = "variant",
  ProductId = "productId",
  VariantId = "variantId",
  VariantName = "variantName",
  SKU = "sku",
  Flags = "flags",
  Rules = "rules",
  Brand = "brand",
  Planner = "planner",
  Category = "category",
  Gender = "gender",
  Tags = "tags",
  Color = "color",
  BaseColor = "baseColor",
  Size = "size",
  SizeDimension1 = "sizeDimension1",
  SizeDimension2 = "sizeDimension2",
  SizeSplitConfidence = "sizeSplitConfidence",
  Fabric = "fabric",
  AvailabilityToday = "availabilityToday",
  OverstockQuantity = "overstockQuantity",
  RightMargin = "rightMargin",
  SuggestedOrder = "suggestedOrder",
  ExistingPO = "existingPo",
  ColliSize = "colliSize",
  Buffer = "buffer",
  WeeksOnHand = "WeeksOnHandsCount",
  Sales = "salesQuantity",
  PreOrders = "preOrderQuantity",
  PreOrdersLastYear = "lastYearPreOrders",
  Forecast = "forecastQuantity",
  StockLevel = "stockLevel",
  ReservedStockLevel = "reservedStockLevel",
  AvailableToSell = "availableToSell",
  InventoryValue = "inventoryValue",
  CostPrice = "costPrice",
  RecommendedRetailPrice = "recommendedRetailPrice",
  WholesalePrice = "wholesalePrice",
  LeadTime = "leadTime",
  ServiceLevel = "serviceLevel",
  SoldSince = "soldSince",
  WeekCover = "weekCover",
  SalesGrowth = "salesGrowth",
  ForecastedGrowth = "forecastedGrowth",
  PurchaseInterval = "purchaseInterval",
  HideColumns = "hideColumns",
  IncomingStock = "incomingStock",
  LostSales = "lostSales",
  Profit = "profit",
  OutOfStockDate = "OutOfStockDate",
  SafetyStockOutDate = "SafetyStockOutDate",
  OptimalOrderDate = "optimalOrderDate",
  StockStatus = "stockStatus",
  MinimumOrderQuantity = "minimumOrderQuantity",
  SecondaryMOQ = "secondaryMOQ",
  AvailabilityWithinLeadTime = "AvailabilityWithinLeadTime",
  LocationAvailability = "LocationAvailability",
  LocationMinimumStockLevel = "LocationMinimumStockLevel",
  ForecastModel = "forecastModel",
  PreferredVendor = "PreferredVendor",
  ABC = "ABC",
  Vendor = "vendor",
  LifecycleStatus = "lifecycleStatus",
  SupplierSku = "supplierSku",
  ProductType = "productType",
  SellThroughRate = "sellThroughRate",
  InventoryTurn = "inventoryTurn",
  GMROI = "gmroi",
  Collection = "collection",
  Revenue = "revenue",
  Returns = "returns",
  ExpectedReturns = "expectedReturns",
  ReturnRate = "returnRate",
  ReturnRateWholeHorizon = "returnRateWholeHorizon",
  OverstockValue = "overstockValue",
  SafetyStockValue = "safetyStockValue",
  NetSales = "netSalesQuantity",
  SalesLast30Days = "salesLast30Days",
  ActivatedFrom = "activatedFrom",
  ActivatedUntil = "activatedUntil",
  PhasingOutFrom = "phasingOutFrom",
  ForecastQuality = "forecastQuality",
  ForecastedGrowthAlert = "forecastedGrowthAlert",
  ForecastInfo = "forecastInfo",
  ForecastedGrowthUnits = "forecastedGrowthAbsolute",
  SalesWithoutPreOrders = "salesWithoutPreOrders",
  ForecastWithoutKnownPreOrders = "forecastWithoutKnownPreOrders",
  PreOrderFulfillment = "preOrderFulfillment",
  UnfulfillablePreorder = "unfulfillablePreorder",
  AtRiskPreorder = "atRiskPreorder",
  ForecastWithoutPreOrders = "forecastWithoutPreOrders",
  GrowthWithoutPreOrders = "growthWithoutPreOrders",
  StockoutImputation = "estimatedStockoutImputation",
  MissingSalesImputation = "estimatedMissingSalesImputation",
  // ForecastBoundApplied = "forecastBoundApplied",
  ForecastSalesVsLy1m = "forecastSalesVsLy01m",
  ForecastSalesVsLy3m = "forecastSalesVsLy03m",
  ForecastSalesVsLy6m = "forecastSalesVsLy06m",
  ForecastSalesVsLy12m = "forecastSalesVsLy12m",
}
